/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input.form-control[_ngcontent-%COMP%]:disabled{background-color:#e3f2fd;opacity:1}"];
export { styles as styles };
